import { createAction } from 'redux-actions';
import ActionTypes from '../constants/ActionTypes';
import { change } from 'redux-form';
import api from '../utils/api';
import { SubmissionError } from 'redux-form';
import qs from 'query-string';

const onSuccess = createAction(ActionTypes.USER_LOGIN_CHECK_SUCCESS);

const setPasswordSuccess = createAction(ActionTypes.SET_PASSWORD_SUCCESS);
const setPasswordError = createAction(ActionTypes.SET_PASSWORD_ERROR);
const facebookConnectSuccess = createAction(ActionTypes.FACEBOOK_CONNECT_SUCCESS);

export const onLoginCheckSuccess = data => dispatch => {
  dispatch(onSuccess(data));
  dispatch(change('GQ', 'phone', data.phone));
};

//set password for the first time - api only works if there is no user-created password set already
export const setPassword = data => async dispatch => {
  try {
    const response = await api.post('/api/success/set-password', data);
    if (response.data.success) {
      const userInfo = await api.get('/system/ajax_handlers/user_info.php');
      dispatch(onLoginCheckSuccess(userInfo.data));
      dispatch(setPasswordSuccess());
    } else {
      dispatch(setPasswordError());
    }
  } catch (e) {
    if (e.response.data.errors) {
      throw new SubmissionError(e.response.data.errors);
    }
  }
};

export const login = (data, link) => async dispatch => {
  try {
    const response = await api.post('/system/ajax_handlers/login.php', data);
    if (response.status === 200) {
      window.location = link;
    } else {
      dispatch({ type: ActionTypes.USER_LOGIN_ERROR, payload: true });
    }
  } catch (e) {
    dispatch({ type: ActionTypes.USER_LOGIN_ERROR, payload: true });
  }
};

export const getLoginInfo = async dispatch => {
  const userInfo = await api.get('/system/ajax_handlers/user_info.php');
  dispatch(onLoginCheckSuccess(userInfo.data));
};

//reset an existing password (eg. if you've forgotten it) - requires token
export const resetPassword = data => async (dispatch, getState) => {
  const state = getState();
  const { location } = state.routing;
  if (!location) return;
  const query = qs.parse(location.search);
  if (query.token) {
    try {
      const response = await api.post(
        `/api/success/reset-unknown-password?token=${query.token}`,
        data
      );
      if (response.data.success) {
        const userInfo = await api.get('/system/ajax_handlers/user_info.php');
        dispatch(onLoginCheckSuccess(userInfo.data));
        dispatch(setPasswordSuccess());
      } else {
        dispatch(setPasswordError());
      }
    } catch (e) {
      if (e.response.data.errors) {
        throw new SubmissionError(e.response.data.errors);
      }
    }
  } else {
    //no token in url
    dispatch(setPasswordError());
  }
};

export const connectFacebook = () => async dispatch => {
  dispatch(facebookConnectSuccess());
};

export function extractTokenFromUrl() {
  return (dispatch, getState) => {
    const state = getState();
    const { location } = state.routing;
    if (!location) return;
    const query = qs.parse(location.search);
    if (query.token) {
      dispatch({ type: ActionTypes.USER_SET_JWT, payload: query.token });
    }
  };
}
